import { promiseImpl } from 'ejs';
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import { Intent, Classes,Popover,Menu,MenuDivider,MenuItem } from "@blueprintjs/core";
import { Button,Radio,RadioGroup, Card, Elevation,Slider, Overlay,H4 } from "@blueprintjs/core";
import {Toaster, Position} from "@blueprintjs/core";
import  {MSG_VISIO} from "../MessagesVisio.js"
const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});

/*const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};*/
export default class CardForceMatiere extends React.Component  <{}> {
  msg_visio=MSG_VISIO;
  state = {
    force_width:680,
    select_matiere_id:"-1",
    choix_matiere:false,
    datamatieres:this.props.datamatieres
  }  
  
  constructor(props) {
        super(props);
      }
  componentDidMount () {     
    var st=localStorage.getItem("select_matiere_id");
    if(st!="")this.setState({select_matiere_id:st}); 
    console.log(this.props.selected_classe_item)
    this.setState({datamatieres:this.props.datamatieres})
  }
 
  componentDidUpdate(prevProps, prevState) {
    if(this.props.datamatieres!=this.state.datamatieres)this.setState({datamatieres:this.props.datamatieres});
  }
  
 
  handletaille=()=>{
    this.setState({force_width:"100%"});
    this.setState({showcontenu:"block"});
    this.setState({elargir:"arrow-left"});
  }
  handleSelectMatiere =(ev)=>{
    //console.log(ev);
    this.setState({select_matiere_id:ev.currentTarget.value});
    localStorage.setItem("select_matiere_id",ev.currentTarget.value);
    this.props.ForcerMatiere(this.props.selected_classe_id,ev.currentTarget.value);
  }
  
  
   render() {
    
    

    return(
     <div>
     <Card style={{width:this.state.force_width,marginLeft:4,marginTop:0, objectFit:'contain'}} interactive={false} elevation={Elevation.TWO}>
     <div>
       <H4>Choisir et forcer une matière pour les étudiants</H4>
       <Button  intent={Intent.PRIMARY} style={{userSelect: 'none', margin: '0px 5px 10px 20px',padding: '1px 30px 1px 5px'}} icon="manual"
        onClick={(ev)=>{ev.preventDefault();this.setState({choix_matiere:true})}}>Choisir une matière</Button>
        <Button  intent={Intent.PRIMARY} style={{userSelect: 'none', margin: '0px 5px 10px 20px'}} title="Envoyer à nouveau" icon="refresh"
        onClick={(ev)=>{ev.preventDefault();this.props.ForcerMatiere(this.props.selected_classe_id,this.state.select_matiere_id);}}></Button>
        <div style={{ margin: '10px 20px 10px'}}>Matière choisie:{this.state.datamatieres.filter((it)=>it.ID==this.state.select_matiere_id).map((itemmat)=>itemmat.matiere)} </div>
      </div>
     </Card>
     <Overlay isOpen={this.state.choix_matiere} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '80px 25%'}}>
                        <H4>Choisir une matière pour tous les groupes</H4>
                        
                        <p style={{marginLeft: 0}}>Le choix d'une matière vous permettra de forcer les étudiants de la classe à travailler seulement avec la matière que vous allez choisir.
                        </p>
                        <p></p>
                        <RadioGroup
                            label="Choix de la matière de travail"
                            onChange={this.handleSelectMatiere}
                            selectedValue={this.state.select_matiere_id}
                        >
                           <Radio label="Aucune" value="-1" />
                           {this.state.datamatieres.map((itemmat)=><Radio label={itemmat.matiere} value={itemmat.ID.toString()} />)}
                        </RadioGroup>
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({choix_matiere:false})}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            
                            
                            
                        </div>
                    </div>
        </Overlay>
     </div>
     
     );
}
}

